import { defaultActionCreator } from "../../actionCreator";

export const SET_STATE = "general/SET_STATE";
export const setState = defaultActionCreator(SET_STATE, "payload");
